/* eslint-disable no-undef */
export default {
	name: "account-information",
	data() {
		return {
			personalDetails: {},
			companyDetails: {},
			loading: false
		};
	},
	methods: {
		getAccountInformation(){
			this.loading = true;
			customerService.getCompany().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//this.shippingAddresses = successResponse.data.result;
						this.personalDetails = {
							firstName: successResponse.data.primaryCustomerUser.firstName,
							lastName: successResponse.data.primaryCustomerUser.lastName,
							emailAddress: successResponse.data.primaryCustomerUser.email,
							//dateOfBirth: "08/05/2023"
						};
						//TODO: get sales rep from api
						this.companyDetails = {
							customerCode: successResponse.data.result.customerCode,
							businessName: successResponse.data.result.registeredCompanyName,
							tradingName: successResponse.data.result.tradingAs,
							holdingCompany: successResponse.data.result.holdingCompany,
							registrationNumber: successResponse.data.result.companyRegistrationNumber,
							telephoneNumber: successResponse.data.result.primaryTelephoneNumber,
							salesRep: successResponse.data.salesReps,
							taxNumber: successResponse.data.result.taxVatNumber
						};
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			console.log("personalDetails", this.personalDetails.firstName);
		}
	},
	mounted: function () {
		storeState.setPageTitleAction("Account Information");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Account Information");
		this.getAccountInformation();
	}
};